(function () {
  "use strict";

  function hideLegacyBookingContent() {
    var root = document.querySelector("[data-alunir-booking-handle]");
    if (!root) return;

    var blocks = root.closest("[data-product-blocks]");
    if (blocks) {
      var legacyStarts = [
        "Beliebte Anlässe:",
        "über 500 Terminbuchungen",
        "Starter-Set: Armband",
        "Permanent Bracelet: Armband",
        "Eine Person pro Termin",
        "Viele verschiedene Anhänger",
        "Zahlung erfolgt vor Ort",
        "1 Jahr Garantie",
      ];

      blocks.querySelectorAll(".product-block").forEach(function (block) {
        if (block === root || block.contains(root)) return;
        var text = (block.textContent || "").replace(/\s+/g, " ").trim();
        if (legacyStarts.some(function (start) { return text.indexOf(start) === 0; })) {
          block.hidden = true;
        }
      });
    }

    document.querySelectorAll("product-recommendations, [data-section-type='recently-viewed']").forEach(function (section) {
      section.hidden = true;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hideLegacyBookingContent);
  } else {
    hideLegacyBookingContent();
  }
})();
